module.exports = __webpack_public_path__ + "static/media/attend_event_map.7ce04995.svg";